var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMerge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 457.242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M403.165 344.599c-11.267 10.838-29.19 10.489-40.028-.777-10.838-11.268-10.49-29.19.777-40.028l48.586-46.565H259.127c-50.679 0-101.483 20.503-139.756 53.688-35.889 31.112-60.435 73.156-62.771 119.349-.734 15.615-13.99 27.678-29.605 26.944C11.38 456.476-.683 443.221.051 427.605c3.171-62.709 35.336-118.786 82.291-159.486 17.804-15.434 37.792-28.689 59.153-39.274-21.437-10.623-41.487-23.931-59.334-39.436C35.187 148.594 3.055 92.408.032 29.637-.702 14.021 11.361.766 26.976.032c15.616-.734 28.871 11.329 29.605 26.944 2.227 46.317 26.734 88.466 62.609 119.635 38.306 33.281 89.186 53.85 139.937 53.85h154.547l-49.76-47.69c-11.267-10.837-11.615-28.761-.777-40.027 10.838-11.267 28.761-11.615 40.028-.778l100.853 96.691a28.173 28.173 0 017.653 15.868l.033.239c.196 1.33.296 2.694.296 4.081 0 9.932-5.107 18.667-12.831 23.74l-96.004 92.014z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerge);
export default __webpack_public_path__ + "static/media/merge.439dded59bb2795e56f948626b91ed0f.svg";
export { ForwardRef as ReactComponent };